import React from 'react'
import { Link } from 'react-router-dom'
import Metrics from '../components/Metrics/Metrics'
import SearchSubscriptionList from '../components/SearchSubscriptionList/SearchSubscriptionList'
import { URL } from '../constants'
import styles from '../styles/Home.module.css'


const Home = () => {
    return (
        <div className="container bodyContainer">
            <h1 className="page-heading page-header">Home</h1>
            <Metrics />
            <SearchSubscriptionList />
            <div className="d-grid gap-2">
                <Link to={URL.search} className={`btn btn-secondary d-flex justify-content-center ${styles.searchRedirectButton}`} tabIndex={-1} role="button" aria-disabled="true">
                    <i className="bi bi-plus me-1"></i>Add Search Subscription
                </Link>
            </div>
        </div>
    )
}

export default Home
